/**
 * Browser-side preview for price-monitoring uploads. Channel + snapshot period are
 * encoded in the FILENAME (KA-IDM / KA-SAT, "Mar26" / "April'26"), not the file
 * body — the workbook is a heterogeneous per-category matrix parsed entirely on the
 * server. So the preview only needs to validate + read the filename, mirroring
 * PriceMonitoringFileParser.parse_filename (the server stays authoritative).
 */

const CHANNEL_RE = /KA[\s\-_]*(IDM|SAT)/i

const MONTHS: Record<string, number> = {
  jan: 1, january: 1, januari: 1,
  feb: 2, february: 2, februari: 2,
  mar: 3, march: 3, maret: 3,
  apr: 4, april: 4,
  may: 5, mei: 5,
  jun: 6, june: 6, juni: 6,
  jul: 7, july: 7, juli: 7,
  aug: 8, august: 8, agustus: 8, agu: 8, agt: 8, ags: 8,
  sep: 9, september: 9, sept: 9,
  oct: 10, october: 10, oktober: 10, okt: 10,
  nov: 11, november: 11,
  dec: 12, december: 12, desember: 12, des: 12,
}

// Longest keys first so "april" beats "apr", "maret" beats "mar", etc.
const MONTH_KEYS = Object.keys(MONTHS).sort((a, b) => b.length - a.length)

export async function parsePriceMonitoringForPreview(file: File): Promise<Record<string, unknown>> {
  const base = file.name

  if (!base.toLowerCase().endsWith(".xlsx")) {
    throw new Error(`Format tidak didukung: "${base}". Price monitoring hanya menerima .xlsx.`)
  }

  const channelMatch = base.match(CHANNEL_RE)
  if (!channelMatch) {
    throw new Error(`Channel KA-IDM / KA-SAT tidak ditemukan di nama file: "${base}".`)
  }
  const channel = channelMatch[1].toUpperCase()

  const low = base.toLowerCase()
  let month = 0
  let year = 0
  for (const key of MONTH_KEYS) {
    const m = low.match(new RegExp(key + "[\\s'’`._-]*(\\d{2,4})"))
    if (m) {
      month = MONTHS[key]
      const y = parseInt(m[1], 10)
      year = y < 100 ? 2000 + y : y
      break
    }
  }
  if (!month || !year) {
    throw new Error(`Bulan/tahun tidak ditemukan di nama file: "${base}" (contoh: "Mar26", "April'26").`)
  }

  return { channel, snapshotYear: year, snapshotMonth: month }
}
